import { isPopulatedNonPrimitive } from './isPopulatedNonPrimitive';
import { isPrimitive } from './isPrimitive';

export const recursivelyCoerceKeyValueToQueryParameter = (
    key: string,
    value: unknown,
    processNestedKey = (_: string, subKeyValue: string): string => subKeyValue
): string => {
    if (isPrimitive(value)) {
        return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
    }
    if (isPopulatedNonPrimitive(value)) {
        return Object.entries(value)
            .map(([subKey, subValue]) =>
                recursivelyCoerceKeyValueToQueryParameter(processNestedKey(key, subKey), subValue, processNestedKey)
            )
            .join('&');
    }
    return `${encodeURIComponent(key)}=`;
};
